
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import Divider from 'vux/src/components/divider/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'


export default {
name: "edit",
components: {
Group,
Cell,
Tabbar,
Checker,
CheckerItem,
Divider,
XInput
},
data() {
return {
priceSetType: 1,
unifiedPrice: null,
weekendPrice: null,
normalPrice: null,
editStartTime: null,
editEndTime: null,
roomBaseInfo: {},
shopId: this.$route.params.shopId,
roomId: this.$route.params.roomId,

}
},
methods: {
editPrice: function () {
let shopId = this.shopId
let roomId = this.roomId
let normalPrice = null
let weekendPrice = null
let startTime = this.editStartTime
let endTime = this.editEndTime
let isDiff = null
if (this.priceSetType == 1) {
console.log(this.unifiedPrice)
isDiff = 0
normalPrice = this.unifiedPrice
weekendPrice = this.unifiedPrice
}
if (this.priceSetType == 2) {
console.log(this.normalPrice)
console.log(this.weekendPrice)
isDiff = 1
normalPrice = this.normalPrice
weekendPrice = this.weekendPrice
}
let uri = '/v1/shop/'+shopId+'/room/'+roomId+'/price/setting?isDiff='+isDiff+'&startTime='+startTime+'&endTime='+endTime+'&weekendPrice='+weekendPrice+'&normalPrice='+normalPrice
let _this = this;
_this.axios.get(uri, null, {
headers: {}
}).then(function (response) {
console.log('改价成功...');



_this.$router.go(-1)
}).catch(function (response) {
console.log(response);
});

},
setUnifiedPrice(value) {

this.unifiedPrice = value
},
setNormalPrice(value) {

this.normalPrice = value
},
setWeekendPrice(value) {

this.weekendPrice = value
},
getRoomBaseInfo(){
let shopId = this.shopId
let roomId = this.roomId
let uri = '/v1/shop/'+ shopId +'/room/' +roomId+ '/base/info';
let _this = this;
_this.axios.get(uri, null, {
headers: {}
}).then(function (response) {
if (response.data.code == 0) {
_this.roomBaseInfo = response.data.data
}
}).catch(function (response) {
console.log(response);
});
},
},
created() {

let startTime = this.$route.query.startTime
let endTime = this.$route.query.endTime
this.editStartTime = startTime
this.editEndTime = endTime
this.getRoomBaseInfo()
},
}



// WEBPACK FOOTER //
// ./src/components/tuan_price/Edit.vue